<template>
  <div>
    <v-btn color="#00ADB5" x-small fab @click="openDialog">
      <v-icon color="#EEEEEE">mdi-file</v-icon>
    </v-btn>

    <v-dialog fullscreen v-model="dialog">
      <v-card color="#222831">
        <v-app-bar
            color="#00ADB5"
            fixed
        >
          <v-toolbar-title>مدیریت فایل ها</v-toolbar-title>

          <v-spacer></v-spacer>

          <v-btn fab icon @click="closeDialog">
            <v-icon color="#EEEEEE">mdi-close</v-icon>
          </v-btn>
        </v-app-bar>

        <v-row class="mt-16">

          <v-col cols="12" md="2">
            <h3>آپلود فایل جدید</h3>
            <file-uploader @fileUploaded="fileUploaded" :upload-percentage="uploadPercentage" label="فایل خود را انتخاب کنید"></file-uploader>
            <v-btn class="mt-6 btn-primary" block depressed @click="submitFile">
              <v-icon left>mdi-upload</v-icon>
              آپلود
            </v-btn>
          </v-col>

          <v-col cols="12" md="10">
            <v-row>
              <v-col v-for="file in files.data" :key="file.id" cols="12" md="3">
                <v-card color="#393E46" class="pa-2 pb-0">

                  <img class="rounded-xl" v-if="file.is_image" :src="file.url" width="100%">
                  <v-btn v-else block color="primary" class="mb-3" target="_blank" :href="file.url">دانلود</v-btn>

                  <p class="dates">{{ file.name }} . {{ file.extension }}</p>
                  <p class="dates">{{ file.persian_created_at }}</p>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on"
                             class="copy-btn" x-small
                             fab color="primary"
                             @click="copy(file.url)">
                        <v-icon>mdi-content-copy</v-icon>
                      </v-btn>
                    </template>
                    <span>کپی url</span>
                  </v-tooltip>

                  <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn v-bind="attrs" v-on="on"
                             class="delete-btn"
                             :x-small="deleteConfirmationID !== file.id"
                             :small="deleteConfirmationID === file.id"
                             fab color="error"
                             @click="deleteFile(file)">
                        <v-icon>mdi-trash-can</v-icon>
                      </v-btn>
                    </template>
                    <span v-if="deleteConfirmationID === file.id">در صورت اطمینان از حذف فایل، دوباره روی سطل کلیک کنید</span>
                    <span v-else>حذف فایل</span>
                  </v-tooltip>


                </v-card>
              </v-col>
            </v-row>
          </v-col>

        </v-row>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import FileUploader from "@/components/File/FileUploader";

export default {
  name: "FileManager",

  components: {FileUploader},

  props: [
    'directory'
  ],

  data() {
    return {
      dialog: false,
      files: [],
      uploadPercentage: 0,
      newFile: null,
      deleteConfirmationID: null
    }
  },

  methods: {
    openDialog() {
      this.dialog = true;
      this.getFiles()
    },

    closeDialog() {
      this.dialog = false;
    },

    getFiles(page = 1) {
      this.$store.dispatch("getPaginatedFiles", page)
          .then((res) => {
            this.files = res.data
          })
    },

    fileUploaded(file) {
      this.newFile = file
    },

    submitFile() {
      let formData = new FormData();

      formData.append('file', this.newFile);
      formData.append('directory', this.directory);

      window.axios.post("/admin/file/upload", formData, {
        onUploadProgress: function (progressEvent) {
          this.uploadPercentage = parseInt(Math.round((progressEvent.loaded / progressEvent.total) * 100));
        }.bind(this)
      }).then(() => {
        this.getFiles()
      })
    },

    deleteFile(file) {
      if (file.id === this.deleteConfirmationID) {
        this.$store.dispatch("deleteFile", file.id).then(() => {
          this.getFiles()
        })
      } else {
        this.deleteConfirmationID = file.id
      }
    },

    copy(content) {
      navigator.clipboard.writeText(content);
      this.$store.dispatch("openSnackbar", {text: 'url کپی شد!'})
    }
  }
}
</script>

<style scoped>
.copy-btn {
  position: absolute;
  bottom: 5px;
  right: 5px;
}
.delete-btn {
  position: absolute;
  bottom: 5px;
  right: 45px;
}
</style>